module.exports = __webpack_public_path__ + "img/icon61.9a51613e.png";